// extracted by mini-css-extract-plugin
module.exports = {"truncated":"RootWrapper_truncated__aVd4V","root":"RootWrapper_root__yVNww","main":"RootWrapper_main__IXrhm","main__woheader":"RootWrapper_main__woheader__4QgFn"};